import { smoothScrollTo } from './scrollUtils.js'

window.addEventListener('DOMContentLoaded', () => {
    const toTopBtn = document.getElementById('to_top-pc')

    window.addEventListener("scroll", () => {
        if (toTopBtn) {
        const scrollY = window.scrollY || document.documentElement.scrollTop
            if (scrollY > 20) {
                toTopBtn.style.display = "block"
            } else {
                toTopBtn.style.display = "none"
            }
        }
    })

    if (toTopBtn) {
        toTopBtn.addEventListener('click', (e) => {
            e.preventDefault()
            const start = window.scrollY
            smoothScrollTo(0, start)
        })
    }
})

